import { SVGProps } from 'react'

export const ChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 4L4.5 19M9.55102 9.0031L9.55102 19M14.602 13.6615L14.602 19M19.5 15.8975L19.5 19"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
